import {
  Alert,
  Card,
  CardHeader,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Skeleton,
} from "@mui/material";
import { type ManagedMission } from "@rescuetablet/missions-client";
import { useOutletContext } from "react-router";
import LinkBehavior from "./LinkBehavior";

export default function MissionListPage() {
  const { missions } = useOutletContext<{
    missions: ReadonlyArray<ManagedMission>;
  }>();

  return (
    <Card>
      <CardHeader title="Wählen Sie einen Einsatz" />
      {missions.length ? (
        <List>
          {missions.map((mission) => (
            <MissionItem key={mission.id} mission={mission} />
          ))}
        </List>
      ) : (
        <Alert severity="info">Keine laufenden Einsätze gefunden.</Alert>
      )}
    </Card>
  );
}

function MissionItem({ mission }: { mission: ManagedMission }) {
  if (mission.state === "loading") {
    return (
      <ListItem>
        <ListItemText primary={<Skeleton />} secondary={<Skeleton />} />
      </ListItem>
    );
  }

  if (mission.state === "error") {
    return <Alert severity="error">{mission.error.message}</Alert>;
  }

  return (
    <ListItemButton component={LinkBehavior} href={mission.id}>
      <ListItemText
        primary={[mission.mission.keyword, mission.mission.message]
          .filter(Boolean)
          .join(" - ")}
        secondary={mission.mission.address}
      />
    </ListItemButton>
  );
}
